<template>
  <div class="sub-ger-certificado">
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA O CONTEUDO DA TELA -->
    <template v-else>
      <table class="dados">
        <tr>
          <td style="width: 50px; text-align: right;" colspan="2">
            <!-- CERTIFICADO DIGITAL VALIDO POR MAIS DE 30 DIAS -->
            <RF-Icones v-if="diferenca >= 31"
              :cpntId='cpntHashId + "icone"'
              :cpntIcone='"check-circulo"'
              :cpntIconeClass='[ "rf-icon-verde" ]'
            ></RF-Icones>

            <!-- CERTIFICADO DIGITAL VENCIDO -->
            <RF-Icones v-else-if="diferenca <= 0"
              :cpntId='cpntHashId + "icone"'
              :cpntIcone='"erro"'
              :cpntIconeClass='[ "rf-icon-vermelho" ]'
            ></RF-Icones>

            <!-- CERTIFICADO DIGITAL VALIDO POR MENOS DE 30 DIAS -->
            <RF-Icones v-else-if="diferenca <= 30"
              :cpntId='cpntHashId + "icone"'
              :cpntIcone='"alerta"'
              :cpntIconeClass='[ "rf-icon-amarelo" ]'
            ></RF-Icones>
          </td>

          <td>
            <!-- SETA O STATUS DO CERTIFICADO -->
            <div style="font-weight: bold;">
              <template v-if="diferenca <= 0">
                Certificado digital está vencido há {{ diferenca * (-1)  }} dias.
              </template>
              <template v-else-if="diferenca > 0">
                Certificado digital vence em {{ diferenca }} dias.
              </template>
            </div>
            
            <!-- SETA A DATA DE VENCIMENTO DO CERTIFICADO -->
            <div>
              Vencimento: {{ data }}
            </div>
          </td>
        </tr>
      </table>

      <template v-if="diferenca >= 0">
        <hr style="margin: 10px;"/>

        <table class="emails" >
          <tr>  
            <td :colspan="Object.keys(emails).length" style="padding-bottom: 10px; text-decoration: underline;">
              Enviar para:
            </td>
          </tr>
          <tr class="itens">
            <td v-for="(email, indexT) in emails" :key="'tipo-' + indexT" :style="'width: calc(100% / ' + Object.keys(emails).length + ')'" :class="indexT === selecionado ? 'selecionado' : ''" @click="subaseGerCertificadoOnChangeSelecionado(indexT)">
              <div>
                <!-- SETA O TITULO DO E-MAIL-->
                <div v-html="indexT" class="titulo"></div>

                <!-- SETA OS E-MAILS -->
                <div>
                  <div v-for="(item, indexI) in email" :key="'tipo-' + indexT + '-item-' + indexI">
                    <span v-html="item"></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>  
            <td :colspan="Object.keys(emails).length" style="padding-top: 10px; padding-bottom: 10px;">
              <RF-Button v-if="Object.keys(buttonEnviar).length >= 1" :data-time='time'
                :cpntStatus='buttonEnviar.status' 
                :cpntId='buttonEnviar.id' 
                :cpntTexto='buttonEnviar.texto' 
                :cpntClass='buttonEnviar.class'
                :cpntMostrar='buttonEnviar.mostrar'
                :cpntDisabled='buttonEnviar.disabled'
                :cpntTabIndex='buttonEnviar.tabIndex'

                @onClickButton='buttonEnviar.onClick'
              ></RF-Button>
            </td>
          </tr>
        </table>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .sub-ger-certificado > table.dados {
    width: 400px;
    margin: 0px auto;
    margin-top: 10px;
  }
    .sub-ger-certificado > table.dados > tr > td > div {
      margin: 5px;
      text-align: center;
    }

  .sub-ger-certificado > table.emails {
    width: 100%;
    text-align: center;
    margin-top: 10px;
    border-collapse: separate;
    border-spacing: 10px;
    /* border: 1px solid #e9e9e9; */
    border-radius: 5px;
  }
    .sub-ger-certificado > table.emails > tr > td {
      vertical-align: top;
    }
      .sub-ger-certificado > table.emails > tr > td > div > .titulo {
        font-weight: bold;
      }
      .sub-ger-certificado > table.emails > tr.itens > td {
        margin: 5px;
        padding: 10px;
        border: 1px solid #fff;
        height: 100%;
      }
      .sub-ger-certificado > table.emails > tr.itens > td.selecionado,
      .sub-ger-certificado > table.emails > tr.itens > td:hover {
        background: #e9e9e9;
        border: 1px solid #ccc;
        cursor: pointer;
        border-radius: 5px;
      }
      .sub-ger-certificado > table.emails > tr > td > button {
        width: 150px;
      }
</style>

<style>
  .sub-ger-certificado > table.dados > tr > td > span > svg {
    font-size: 50px;
  }
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'sub-ger-certificado-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntClu: {
        require: true
      },
      cpntFecharFormulario: {
        require: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        selecionado: '',
        data: null,
        diferenca: null,
        emails: {}
      }
    },
    mounted: function () {
      this.subaseGerCertificadoIniciar()
    },
    methods: {
      subaseGerCertificadoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.subaseGerCertificadoSetarStatusGeral('carregando')

        // SETA O BOTÃO PARA ENVIAR
        this.buttonEnviar = {
          status: '',
          id: this.cpntHashId + 'button-env',
          texto: 'Enviar',
          class: [ 'btn', 'btn-primary' ],
          disabled: true,
          onClick: this.subaseGerCertificadoEnviar
        }

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(null, {
          subaseGerCertificadoBuscarDados: [ ],
          subaseGerCertificadoBuscarEmails: [ ],
          subaseGerCertificadoFinalizar: [ 'subaseGerCertificadoBuscarDados', 'subaseGerCertificadoBuscarEmails' ]
        },
        {
          subaseGerCertificadoBuscarDados: (chave, callback) => { this.subaseGerCertificadoBuscarDados(() => { callback(chave) } ) },
          subaseGerCertificadoBuscarEmails: (chave, callback) => { this.subaseGerCertificadoBuscarEmails(() => { callback(chave) } ) },
          subaseGerCertificadoFinalizar: (chave, callback) => { this.subaseGerCertificadoFinalizar(() => { callback(chave) } ) },
        })
      },
      subaseGerCertificadoFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      },
      subaseGerCertificadoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subaseGerCertificadoOnChangeSelecionado: function (indexT) {
        // SETA O STATUS DA TELA
        this.selecionado = indexT === this.selecionado ? '' : indexT

        // VERIFICA SE DEVE ATIVAR OU DESATIVAR O BOTÃO DE ENVIAR
        this.buttonEnviar.disabled = [ '', null, undefined ].indexOf(this.selecionado) !== -1

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subaseGerCertificadoBuscarDados: function (callback = null) {
        // INICIA O QUERYGET
        var queryGet = { type: 'list', field: { cda1_val: null }, limit: { row: 0, qty: 10 } }

        // SETA O WHERE A SER REALIZADO
        queryGet.where = { f: 'clu', o: '=', v: this.cpntClu }

        // REALIZA A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/subase/cli-rotinafacil/get', 'POST', queryGet, (apiSuccess) => {
          // IMPORTA BIBLIOTECA DEPENDENTE
          var moment = require('moment')

          // CONVERTE A DATA DO BLOQUEIO
          var certificadoData = moment(apiSuccess.data[0].cda1_val, 'YYYY-MM-DD HH:mm:ss')

          // CALCULA A DIFERENÇA DAS DATAS
          this.diferenca = certificadoData.diff(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss'), 'days')

          // SETA A DATA FORMATADA DO CERTIFICADO
          this.data = certificadoData.format('DD/MM/YYYY') + ' às ' + certificadoData.format('HH:mm:ss')

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.subaseGerCertificadoSetarStatusGeral)
      },
      subaseGerCertificadoBuscarEmails: function (callback = null) {
        // REALIZA A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/subase/painel/certificado/env-email/get/', 'GET', this.cpntClu, (emails) => {
          // FAZ A SEPARAÇÃO DOS E-MAILS
          for (var indexC in emails) {
            // SEPARA OS E-MAILS
            emails[indexC] = emails[indexC].split(';')
            
            // REMOVER VALORES DUPLICADOS
            emails[indexC] = emails[indexC].filter((v, i, a) => [ '', null, undefined ].indexOf(v) === -1 && a.indexOf(v) === i)
          }

          // SETA A OPÇÃO INICIAL MARCADA
          if ([ '', null, undefined ].indexOf(emails.SuporteRF) === -1) {
            this.subaseGerCertificadoOnChangeSelecionado('SuporteRF')
          }

          // SETA OS E-MAILS RECEBIDOS
          this.emails = emails

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.subaseGerCertificadoSetarStatusGeral)
      },
      subaseGerCertificadoFinalizar: function (callback = null) {
        // SETA O STATUS DA PAGINA
        this.subaseGerCertificadoSetarStatusGeral('')

        // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      subaseGerCertificadoEnviar: function () {
        if (confirm('Deseja realmente enviar este certificado digital para ' + this.selecionado + '?')) {
          // SETA O STATUS DO BUTTON
          this.buttonEnviar.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = {}

          // SETA O CODIGO DA LICENÇA DE USO
          formData.clu = this.cpntClu

          // SETA O DESTINATARIO
          formData.destinatario = this.selecionado

          // REALIZA A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/subase/painel/certificado/env-email', 'POST', formData, (apiSuccess) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // CHAMA A FUNÇÃO PARA FECHAR A TELA
            this.subaseGerCertificadoFechar(true)
          }, this.subaseGerCertificadoSetarStatusGeral)
        }
      }
    }
  }
</script>
